import { addMinutes, getUnixTime } from 'date-fns';
import { getJobEnd, getJobStart } from '../shared/helpers/getJobStart';
import { ArchiveAtTypeEnum } from '../shared/models/archiveAtEnum';
import { Customer } from '../shared/models/customer';
import { Job } from '../shared/models/job';

export function getArchiveAt(
  customer: Customer,
  job: Pick<Job, 'shifts' | 'date'>,
) {
  let archiveAt = getJobEnd(job.shifts, job.date);
  if (customer.archiveAtType === ArchiveAtTypeEnum.START_OF_JOB) {
    archiveAt = getJobStart(job.shifts, job.date);
  }
  if (customer.archiveAtOffset !== undefined) {
    archiveAt = addMinutes(archiveAt, customer.archiveAtOffset);
  }
  return getUnixTime(archiveAt);
}
